import { Box } from '@chakra-ui/react';
import { ReactNode } from 'react';
import Navbar from './Navbar';
import Footer from './Footer';

interface LayoutProps {
  children: ReactNode;
}

const Layout = ({ children }: LayoutProps) => {
  return (
    <Box minH="100vh" display="flex" flexDirection="column">
      <Navbar />
      {/* pt="64px" compensates for the fixed Navbar height */}
      <Box flex="1" pt="64px">
        {children}
      </Box>
      <Footer />
    </Box>
  );
};

export default Layout;